import { render, staticRenderFns } from "./ShopFloorCategory.vue?vue&type=template&id=55f2ccec&scoped=true&"
import script from "./ShopFloorCategory.vue?vue&type=script&lang=js&"
export * from "./ShopFloorCategory.vue?vue&type=script&lang=js&"
import style0 from "./ShopFloorCategory.vue?vue&type=style&index=0&id=55f2ccec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55f2ccec",
  null
  
)

export default component.exports